module.exports = __webpack_public_path__ + "static/media/next-arrow-grey.6de2b315.svg";